import './App.css';
import { About, Contact, Experience, Footer, Header, Nav, Portfolio, Services } from './components/index'


function App() {
  return (
    <div>
        <Header />
        <Nav />
        <About />
        {/* <Experience /> */}
        <Services />
        <Portfolio />
        <Contact />
        <Footer />
    </div>
  );
}

export default App;
